import React, { useState } from "react";
import "./ClassListPopUp.css";

const ClassListPopUp = ({
  classList,
  courses,
  teachers,
  students,
  handleUpdateClassList,
  type,
  handleClose,
}) => {
  console.log("Rendering ClassListPopUp"); // Add this line

  const [activeTab, setActiveTab] = useState(0);
  const [className, setClassName] = useState(classList?.className || "");
  const [selectedCourses, setSelectedCourses] = useState(
    Array.isArray(classList?.courseIds) ? classList.courseIds : []
  );
  const [selectedTeachers, setSelectedTeachers] = useState(
    Array.isArray(classList?.teachers) ? classList.teachers : []
  );
  const [selectedStudents, setSelectedStudents] = useState(
    Array.isArray(classList?.students) ? classList.students : []
  );
  const [searchCourse, setSearchCourse] = useState("");
  const [searchTeacher, setSearchTeacher] = useState("");
  const [searchStudent, setSearchStudent] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  const isCreateMode = type === "create";

  const handleSelectCourse = (courseId) => {
    setSelectedCourses((prev) =>
      prev.includes(courseId)
        ? prev.filter((id) => id !== courseId)
        : [...prev, courseId]
    );
  };

  const handleSelectTeacher = (teacherId) => {
    setSelectedTeachers((prev) => {
      const newSelection = prev.includes(teacherId)
        ? prev.filter((id) => id !== teacherId)
        : [...prev, teacherId];
      return newSelection;
    });
  };

  const handleSelectStudent = (studentId) => {
    setSelectedStudents((prev) => {
      const newSelection = prev.includes(studentId)
        ? prev.filter((id) => id !== studentId)
        : [...prev, studentId];
      return newSelection;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!className.trim()) {
      alert("Please enter a class list name for your new class list");
      return;
    }

    setIsSaving(true);
    const updatedClassList = {
      className: className.trim(),
      courseIds: selectedCourses,
      teachers: selectedTeachers,
      students: selectedStudents,
    };
    try {
      await handleUpdateClassList(
        updatedClassList,
        type === "edit" ? classList.id : null
      );
    } catch (error) {
      console.error("Error updating class list:", error);
      alert(error.message || "An error occurred while saving the class list");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="edit-class-list-modal">
      <div className="edit-class-list-modal-content">
        <div className="modal-header">
          {isCreateMode && (
            <h2 className="class-list-popup-title">Create a New Class List</h2>
          )}
          <button className="close-button" onClick={handleClose}>
            &times;
          </button>
        </div>
        <div className="tabs">
          {["Courses", "Teachers", "Students"].map((tab, index) => (
            <button
              key={index}
              className={`tab-button ${activeTab === index ? "active" : ""}`}
              onClick={() => setActiveTab(index)}
            >
              {tab}
            </button>
          ))}
        </div>
        <form className="edit-class-list-form" onSubmit={handleSubmit}>
          {activeTab === 0 && (
            <div className="tab-content">
              <div className="class-list-popup-form-group">
                {isCreateMode && (
                  <div className="class-list-popup-guide">
                    <p
                      className={`guide-step ${
                        className.trim() ? "completed" : ""
                      }`}
                    >
                      Step 1: Give your new class list a name
                    </p>
                  </div>
                )}
                <label>Class List Name</label>
                <input
                  type="text"
                  value={className}
                  onChange={(e) => setClassName(e.target.value)}
                  placeholder="Add a name for your new class list..."
                  className="class-list-popup-search-input"
                />
              </div>
              <div className="class-list-popup-form-group">
                {isCreateMode && (
                  <div className="class-list-popup-guide">
                    <p
                      className={`guide-step ${
                        selectedCourses.length > 0 ? "completed" : ""
                      }`}
                    >
                      Step 2: Link this class list to an existing course
                    </p>
                  </div>
                )}
                <label>Link Courses</label>
                <input
                  type="text"
                  value={searchCourse}
                  onChange={(e) => setSearchCourse(e.target.value)}
                  placeholder="Search existing courses to link your class list..."
                  className="class-list-popup-search-input"
                />
                <ul className="class-list-popup-user-list">
                  {courses
                    .filter((course) =>
                      course.courseName
                        .toLowerCase()
                        .includes(searchCourse.toLowerCase())
                    )
                    .map((course) => (
                      <li
                        key={course.id}
                        className="class-list-popup-user-item"
                      >
                        <label className="class-list-popup-user-label">
                          <input
                            type="checkbox"
                            className="class-list-popup-user-checkbox"
                            checked={selectedCourses.includes(course.id)}
                            onChange={() => handleSelectCourse(course.id)}
                          />
                          <span className="class-list-popup-user-name">
                            {course.courseName}
                          </span>
                        </label>
                      </li>
                    ))}
                </ul>
              </div>
              <div
                className="selected-users-box"
                data-count={`Total Courses: (${selectedCourses.length})`}
              >
                {selectedCourses.map((courseId) => {
                  const course = courses.find((c) => c.id === courseId);
                  return course ? `${course.courseName}, ` : "";
                })}
              </div>
              {isCreateMode && (
                <div className="class-list-popup-guide">
                  <p className="guide-step">
                    ↑ Now, go up and select the "Teachers" tab.
                  </p>
                </div>
              )}
            </div>
          )}
          {activeTab === 1 && (
            <div className="tab-content">
              <div className="class-list-popup-form-group">
                {isCreateMode && (
                  <div className="class-list-popup-guide">
                    <p
                      className={`guide-step ${
                        selectedTeachers.length > 0 ? "completed" : ""
                      }`}
                    >
                      Step 3: Add teachers to share this class list, if you wish
                      (optional).
                    </p>
                  </div>
                )}
                <label>Search Teachers</label>
                <input
                  type="text"
                  value={searchTeacher}
                  onChange={(e) => setSearchTeacher(e.target.value)}
                  placeholder="Search teachers..."
                  className="class-list-popup-search-input"
                />
                <ul className="class-list-popup-user-list">
                  {teachers
                    .filter((teacher) =>
                      `${teacher.firstName} ${teacher.lastName}`
                        .toLowerCase()
                        .includes(searchTeacher.toLowerCase())
                    )
                    .map((teacher) => (
                      <li
                        key={teacher.id}
                        className="class-list-popup-user-item"
                      >
                        <label className="class-list-popup-user-label">
                          <input
                            type="checkbox"
                            className="class-list-popup-user-checkbox"
                            checked={selectedTeachers.includes(teacher.id)}
                            onChange={() => handleSelectTeacher(teacher.id)}
                          />
                          <span className="class-list-popup-user-name">
                            {`${teacher.firstName} ${teacher.lastName}`}
                          </span>
                        </label>
                      </li>
                    ))}
                </ul>
              </div>
              <div
                className="selected-users-box"
                data-count={`Total Teachers: (${selectedTeachers.length})`}
              >
                {selectedTeachers.map((teacherId) => {
                  const teacher = teachers.find((t) => t.id === teacherId);
                  return teacher
                    ? `${teacher.firstName} ${teacher.lastName}, `
                    : "";
                })}
              </div>
              {isCreateMode && (
                <div className="class-list-popup-guide">
                  <p className="guide-step">
                    ↑ Now, move to the "Students" tab.
                  </p>
                </div>
              )}
            </div>
          )}
          {activeTab === 2 && (
            <div className="tab-content">
              <div className="class-list-popup-form-group">
                {isCreateMode && (
                  <div className="class-list-popup-guide">
                    <p
                      className={`guide-step ${
                        selectedStudents.length > 0 ? "completed" : ""
                      }`}
                    >
                      Step 4: Add existing students to this class list.
                    </p>
                  </div>
                )}
                <label>Search Students</label>
                <input
                  type="text"
                  value={searchStudent}
                  onChange={(e) => setSearchStudent(e.target.value)}
                  placeholder="Search students..."
                  className="class-list-popup-search-input"
                />
                <ul className="class-list-popup-user-list">
                  {students
                    .filter((student) =>
                      `${student.firstName} ${student.lastName}`
                        .toLowerCase()
                        .includes(searchStudent.toLowerCase())
                    )
                    .map((student) => (
                      <li
                        key={student.id}
                        className="class-list-popup-user-item"
                      >
                        <label className="class-list-popup-user-label">
                          <input
                            type="checkbox"
                            className="class-list-popup-user-checkbox"
                            checked={selectedStudents.includes(student.id)}
                            onChange={() => handleSelectStudent(student.id)}
                          />
                          <span className="class-list-popup-user-name">
                            {`${student.firstName} ${student.lastName}`}
                          </span>
                        </label>
                      </li>
                    ))}
                </ul>
              </div>
              <div
                className="selected-users-box"
                data-count={`Total Students: (${selectedStudents.length})`}
              >
                {selectedStudents.map((studentId) => {
                  const student = students.find((s) => s.id === studentId);
                  return student
                    ? `${student.firstName} ${student.lastName}, `
                    : "";
                })}
              </div>
              {isCreateMode && (
                <div className="class-list-popup-guide">
                  <p className="guide-step">
                    ↓ Click "Save" if you're done setting up the class list!
                  </p>
                </div>
              )}
            </div>
          )}
          <button
            type="submit"
            className="class-list-popup-submit"
            disabled={isSaving}
          >
            {isSaving ? "Saving..." : "Save"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ClassListPopUp;
